
// FIFA World Rankings — approximate for World Cup 2026
// Keyed by API-Sports team ID
const FIFA_RANKINGS: Record<number, number> = {
    26: 1,    // Argentina
    2: 2,     // France
    9: 3,     // Spain
    10: 4,    // England
    6: 5,     // Brazil
    1118: 6,  // Netherlands
    27: 7,    // Portugal
    1: 8,     // Belgium
    8: 9,     // Colombia
    25: 10,   // Germany
    768: 11,  // Italy
    31: 12,   // Morocco
    3: 13,    // Croatia
    12: 14,   // Japan
    15: 15,   // Switzerland
    7: 16,    // Uruguay
    2384: 17, // United States
    13: 18,   // Senegal
    16: 19,   // Mexico
    20: 20,   // Australia
    21: 21,   // Denmark
    2382: 22, // Ecuador
    22: 23,   // Iran
    14: 24,   // Serbia
    17: 25,   // South Korea
    1532: 26, // Algeria
    24: 27,   // Poland
    772: 28,  // Ukraine
    775: 29,  // Austria
    5: 30,    // Sweden
    1090: 31, // Norway
    1108: 32, // Scotland
    777: 33,  // Turkey (Türkiye)
    770: 34,  // Czech Republic
    769: 35,  // Hungary
    1113: 36, // Bosnia and Herzegovina
    1501: 37, // Ivory Coast
    774: 38,  // Romania
    19: 39,   // Nigeria
    773: 40,  // Slovakia
    767: 41,  // Wales
    1117: 42, // Greece
    1530: 43, // Cameroon
    1500: 44, // Mali
    1533: 45, // Cape Verde
    1568: 46, // Uzbekistan
    28: 47,   // Tunisia
    32: 48,   // Egypt
    1531: 49, // South Africa
    2380: 50, // Paraguay
    2379: 51, // Venezuela
    5529: 52, // Canada
    23: 53,   // Saudi Arabia
    1569: 54, // Qatar
    1567: 55, // Iraq
    11: 56,   // Panama
    2383: 57, // Chile
    4672: 58, // Honduras
    1504: 59, // Ghana
    1508: 60, // DR Congo
    2385: 61, // Jamaica
    2381: 62, // Bolivia
    1571: 63, // Indonesia
    29: 64,   // Costa Rica
    5159: 65, // El Salvador
    30: 66,   // Peru
    2386: 95, // Haiti
};

export const getFifaRanking = (teamId: string | number): number | null => {
    const id = typeof teamId === 'string' ? parseInt(teamId, 10) : teamId;
    if (isNaN(id)) return null;
    return FIFA_RANKINGS[id] ?? null;
};
